import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { useWhatsappConfiguration } from "./models/useWhatsappConfiguration";
import { Button } from "V2.0/common/button";

import { WhatsappForm } from "./components/Whatsapp_form";
import { WhatsappManager } from "./components/Whatsapp_manager";
import { deleteWhatsAppConfig } from "V2.0/services/whatsappService";
import { showErrorToast } from "V2.0/utils";
import LlamaIcon from "V2.0/HomePages/Assistants/ModelSettings/Icons/LlamaIcon";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

function WhatsappTitle() {
  return (
    <div className="flex gap-x-2 items-center">
      <LlamaIcon
        width={24}
        height={24}
      />
      <h3 className="text-base font-semibold">Meta - Whatsapp</h3>
    </div>
  );
}

export function WhatsappShell({ title, onDisconnect, children, isViewOnly }) {
  return (
    <div className="flex flex-col h-full gap-y-4">
      <div className="flex-shrink-0">
        <div className=" flex items-center gap-x-4">
          {title}
          <div className="flex items-center gap-x-2">
            {!isViewOnly && (
              <Button
                outline
                onClick={onDisconnect}
              >
                Disconnect
              </Button>
            )}
          </div>
        </div>
      </div>
      {children}
    </div>
  );
}


function Whatsapp() {
  const { activeProject, projects, projectId, isViewOnly } = useOutletContext();
  const { whatsappConfiguration, fetchWhatsappConfiguration } =
    useWhatsappConfiguration(projects[activeProject]?._id);

  const handleDisconnect = async () => {
    try {
      const response = await deleteWhatsAppConfig(projectId);
      if (response.status === 200) {
        fetchWhatsappConfiguration(projectId);
      }
    } catch (error) {
      showErrorToast(error, "Failed to disconnect");
    }
  };

  if (whatsappConfiguration.loading) {
    return (
      <div className="space-y-4">
        <WhatsappTitle />
        <div className="min-h-96 flex items-center justify-center max-w-lg border rounded-lg">
          <AiOutlineLoading3Quarters className="animate-spin" />
        </div>
      </div>
    );
  }

  if (whatsappConfiguration.isConfigured) {
    return (
      <WhatsappShell
        title={<WhatsappTitle />}
        onDisconnect={handleDisconnect}
        isViewOnly={isViewOnly}
      >
        <WhatsappManager
          existingConfiguration={whatsappConfiguration.data}
          projectId={projects[activeProject]?._id}
          fetchWhatsappConfiguration={fetchWhatsappConfiguration}
          isViewOnly={isViewOnly}
        />
      </WhatsappShell>
    );
  }

  if (!whatsappConfiguration.isConfigured && !whatsappConfiguration.loading) {
    return (
      <div className="h-full flex-1 flex flex-col min-h-96 gap-y-4">
        <WhatsappTitle />

        <WhatsappForm
          projectId={projects[activeProject]?._id}
          fetchWhatsappConfiguration={fetchWhatsappConfiguration}
          isViewOnly={isViewOnly}
        />
      </div>
    );
  }
}

export default Whatsapp;
